import React from "react";
import Card  from "./Card"

import CardPaginator from "~/components/paginator"

import Task          from '~/services/tasks';


const ClaimedTasks = ({setSelectedTask, setOverlayOpen})=> {

  return (
    <div className="history-list">
      <CardPaginator endpoint={Task.paginators.claimed} card={Card} options={{setSelectedTask, setOverlayOpen}} />
    </div>
  );
}

export default ClaimedTasks;
